<template>
    <confirmation-dialog :title="title" :width="width" :value="value" @onCancel="$emit('cancel', $event)" @onSuccess="$emit('success', $event)">
        <template v-slot:optional>
            <p v-if="product.orderable && messages.orderable" v-html="tHtml(messages.orderable)"></p>

            <p v-else-if="product.serializable && messages.serializable" v-html="tHtml(messages.serializable)"></p>
        </template>
    </confirmation-dialog>
</template>

<script>
import { axios } from '@/Services/Backend';

export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },

        title: {
            type: String,
            required: true,
        },

        width: {
            type: String,
            required: true,
        },

        product: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            messages: {
                orderable: null,
                serializable: null,
            },
        };
    },

    created() {
        this.getPurchaseConditions();
    },

    methods: {
        getPurchaseConditions() {
            axios
                .get('/api/products/purchase-conditions')
                .then((response) => {
                    this.messages = response.data;
                })
                .catch((error) => {
                    console.log(error);

                    this.showError(this.$t('toasts.purchaseConditionsError'));
                });
        },
    },
};
</script>
